import React from 'react';
import ProcessoJudicial from "~/components/ProcessoJudicial";
import {SimpleLoading} from "~/components";

const CaseCover = ({caseCover}) => {
  return (
    <>
      {caseCover !== null ? <ProcessoJudicial data={caseCover.data} isCaseCoverScreen={true}/> : <SimpleLoading />}
    </>
  )
}

export default CaseCover;
